module.exports = __webpack_public_path__ + "static/media/PDF_57.d87539fe.pdf";